












import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseInputFileWithPreview from "@/components/BaseInputFileWithPreview";
import BaseThumbnailButton from "@/components/BaseThumbnailButton";

export default defineComponent({
  name: "MediaFileAddButton",
  components: { BaseInputFileWithPreview, BaseButton, BaseThumbnailButton },
  props: {
    accept: { type: Array as () => string[] | undefined, required: false },
    multiple: { type: Boolean, default: false },
    mobileHideText: { type: Boolean, default: false },
    title: { type: String },
  },
});
